(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/numbergames-related/assets/components/pay-confirmation.js') >= 0) return;  svs.modules.push('/modules/numbergames-related/assets/components/pay-confirmation.js');

'use strict';

const {
  useEffect,
  useState
} = React;
const {
  fetchAndSummarizeWagers
} = svs.numbergames_related.utils;
const {
  wagers,
  branding
} = svs.numbergames_related.data;
const Icon = svs.ui.ReactIcon;
const PayConfirmation = () => {
  var _svs$utils$paramHandl, _svs$utils$paramHandl2, _svs$utils$paramHandl3, _svs$utils$paramHandl4;
  const wagerIds = (_svs$utils$paramHandl = svs.utils.paramHandler.get({
    key: 'wagerIds'
  })) === null || _svs$utils$paramHandl === void 0 ? void 0 : _svs$utils$paramHandl.value;
  const ticketAmount = (_svs$utils$paramHandl2 = svs.utils.paramHandler.get({
    key: 'tickets'
  })) === null || _svs$utils$paramHandl2 === void 0 ? void 0 : _svs$utils$paramHandl2.value;
  const ticketId = (_svs$utils$paramHandl3 = svs.utils.paramHandler.get({
    key: 'ticketId'
  })) === null || _svs$utils$paramHandl3 === void 0 ? void 0 : _svs$utils$paramHandl3.value;
  const partialPaymentFailed = (_svs$utils$paramHandl4 = svs.utils.paramHandler.get({
    key: 'partialPaymentFailed'
  })) === null || _svs$utils$paramHandl4 === void 0 ? void 0 : _svs$utils$paramHandl4.value;
  const [title, setTitle] = useState('');
  const [messages, setMessages] = useState([]);
  useEffect(() => {
    let isMounted = true;
    (async () => {
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) && wagerIds) {
        const result = await fetchAndSummarizeWagers({
          wagerIds,
          wagers,
          branding,
          ticketAmount: parseInt(ticketAmount, 10),
          ticketId,
          partialPaymentFailed
        });
        if (isMounted) {
          setTitle((result === null || result === void 0 ? void 0 : result.title) || "Ditt ".concat(branding, " \xE4r betalat! Lycka till!"));
          setMessages((result === null || result === void 0 ? void 0 : result.messages) || []);
          svs.utils.paramHandler.remove({
            key: 'wagerIds'
          }, {
            key: 'tickets'
          }, {
            key: 'ticketId'
          }, {
            key: 'partialPaymentFailed'
          });
        }
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [wagerIds, ticketAmount, ticketId, partialPaymentFailed]);
  if (!wagerIds || !title) {
    return null;
  }
  return React.createElement("div", {
    className: "pay-content"
  }, React.createElement("div", {
    className: "".concat(branding, "-pay-confirm pay-confirmation-container align-center")
  }, React.createElement("span", {
    className: "icon"
  }, React.createElement(Icon, {
    icon: "thumbs-up",
    size: "900"
  })), React.createElement("h1", {
    className: "f-bold"
  }, title), React.createElement("div", {
    className: "messages"
  }, messages === null || messages === void 0 ? void 0 : messages.map((msg, idx) =>
  React.createElement("p", {
    key: "msg-".concat(idx)
  }, msg)))));
};
setGlobal('svs.numbergames_related.components', {
  PayConfirmation
});

 })(window);